import React, { useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import { config, KeyUri } from '../key';
import { toast } from 'react-toastify';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../firebaseconfig';
import { useSelector } from 'react-redux';
import { authenticateSelector } from '../api/userAuth';

function ApplyForm() {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const { isAuthenticate, user } = useSelector(authenticateSelector);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address1: '',
    city: '',
    state: '',
    experience: '',
    resumeURL: '',
    coverLetterURL: '',
    consent: false,
  });

  const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
 const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredStates = indianStates.filter((state) =>
    state.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (state) => {
    setFormData((prev) => ({ ...prev, state }));
    setSearch(state);
    setShowDropdown(false);
  };
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
      // For name: allow only letters and spaces
  if (name === 'name') {
    const regex = /^[A-Za-z\s]*$/;
    if (!regex.test(value)) {
      return;
    }
  }

  // For phone: allow only digits and max length 10
  if (name === 'phone') {
    const regex = /^[0-9]*$/;
    if (!regex.test(value)) {
      return; // ignore non-digit input
    }
    if (value.length > 10) {
      return; // don't allow more than 10 digits
    }
  }
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileUpload = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
      toast.error("Only PDF or Word documents are allowed.");
      return;
    }
    if (file.size > 500 * 1024) {
    toast.error("File size must not exceed 500KB.");
    return;
  }

    const storageRef = ref(storage, `JobApplications/${type}_${Date.now()}_${file.name}`);
    setUploading(true);

    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress.toFixed(0));
      },
      (error) => {
        console.error("Upload failed", error);
        toast.error("File upload failed.");
        setUploading(false);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setFormData((prev) => ({
          ...prev,
          [type]: downloadURL,
        }));
        toast.success(`${type === 'resumeURL' ? 'Resume' : 'Cover letter'} uploaded successfully.`);
        setUploading(false);
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

     // Validation for phone: 10 digits and not starting with 0
  if (!/^[1-9][0-9]{9}$/.test(formData.phone)) {
    toast.error("Phone number must be 10 digits and not start with 0.");
    return;
  }

  if (!formData.name.trim()) {
    toast.error("Name is required and should only contain letters.");
    return;
  }
  
    if (!formData.consent) {
      alert("You must consent to store your data to proceed.");
      return;
    }

    if (!formData.resumeURL) {
      alert("Please upload your resume before submitting.");
      return;
    }

    const payload = {
      jobId: id,
      userId: user?._id, // <-- Include user ID here
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      address1: formData.address1,
      city: formData.city,
      state: formData.state,
      experienceLevel: formData.experience,
      resume: formData.resumeURL,
      coverLetter: formData.coverLetterURL || '',
      consentToStoreData: formData.consent,
    };

    try {
      const token = JSON.parse(localStorage.getItem("tokenUser"));
      await axios.post(`${KeyUri.BACKEND_URI}/apply`, payload,  {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Application submitted successfully!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        experience: '',
        resumeURL: '',
        coverLetterURL: '',
        consent: false,
      })
      // navigate("/thank-you");
    } catch (error) {
      console.error('Error submitting application:', error?.response?.data || error.message);
      toast.error('Application submission failed.');
    }
  };
 

  
  return (

    
    <>
  <div className="max-w-3xl p-6 mt-18 sm:mt-12 md:mt-32 sm:mb-4 md:mb-2 font-lato">
    <span
      onClick={() => navigate(-1)}
      className="text-blue-600 hover:underline cursor-pointer"
    >
      ← Go Back
    </span>
  </div>

  {isAuthenticate ? (
    <div className="max-w-3xl mx-auto p-6 mt-4 bg-white shadow-md rounded-lg font-lato mb-10">
      <h1 className="text-2xl font-bold mb-4">Apply for this Job</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} className="w-full border p-2 rounded" required />
        <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} className="w-full border p-2 rounded" required />
        <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="w-full border p-2 rounded" required />
        <input type="text" name="address1" placeholder="Address Line 1" value={formData.address1} onChange={handleChange} className="w-full border p-2 rounded" required />
        <input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} className="w-full border p-2 rounded" required />
       <div className="relative">
  <input
    type="text"
    name="state"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setFormData((prev) => ({ ...prev, state: e.target.value }));
      setShowDropdown(true);
    }}
    onFocus={() => setShowDropdown(true)}
    placeholder="Select or type state"
    className="w-full border p-2 rounded"
    required
  />

  {showDropdown && filteredStates.length > 0 && (
    <ul className="absolute w-full border bg-white max-h-40 overflow-y-auto rounded shadow-md z-10">
      {filteredStates.map((state, index) => (
        <li
          key={index}
          onClick={() => handleSelect(state)}
          className="px-3 py-2 cursor-pointer hover:bg-blue-100"
        >
          {state}
        </li>
      ))}
    </ul>
  )}
</div>


        <select name="experience" value={formData.experience} onChange={handleChange} className="w-full border p-2 rounded" required>
          <option value="">Select Experience Level</option>
          <option value="Fresher">Fresher</option>
          <option value="0-1 years">0–1 years</option>
          <option value="2-3 years">2–3 years</option>
          <option value="4+ years">4+ years</option>
        </select>

        <div>
          <label className="block mb-1 font-semibold">Upload Resume (PDF/DOC)</label>
          <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={(e) => handleFileUpload(e, 'resumeURL')} className="w-full" required />
        </div>

        <div>
          <label className="block mb-1 font-semibold">Upload Cover Letter (optional)</label>
          <input type="file" name="coverLetter" accept=".pdf,.doc,.docx" onChange={(e) => handleFileUpload(e, 'coverLetterURL')} className="w-full" />
        </div>

        {uploading && (
          <div className="text-sm text-gray-500">Uploading... {uploadProgress}%</div>
        )}

        <div className="flex items-center">
          <input type="checkbox" name="consent" checked={formData.consent} onChange={handleChange} className="mr-2" />
          <label htmlFor="consent" className="text-sm">I consent to have my data stored for recruitment purposes.</label>
        </div>

        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" disabled={uploading}>
          Submit Application
        </button>
      </form>
    </div>
  ) : (
    <div className="max-w-2xl mx-auto p-6 mt-10 bg-white shadow-md rounded-lg text-center font-lato">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Please Log In</h1>
      <p className="text-gray-600 mb-6">You need to log in to apply for this job.</p>
      <button
        onClick={() => navigate('/userprofile')}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
      >
        Go to Login
      </button>
    </div>
  )}
</>

  );
}

export default ApplyForm;
